import { render, staticRenderFns } from "./DomiciliosEdit.vue?vue&type=template&id=36835926&"
import script from "./DomiciliosEdit.vue?vue&type=script&lang=js&"
export * from "./DomiciliosEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports